import { generateHashForHmacSHA256, genericDecrypt, } from "@domains/utils/encryption";
export var loginFeatureMapper = function (res, reqId) {
    var result = {};
    if (res && res.success) {
        var data = null;
        if (typeof res.data === "string") {
            var decryptedString = genericDecrypt(process.env.AES_KEY, process.env.AES_IV, res.data, 32);
            data = JSON.parse(decryptedString);
            if ((data === null || data === void 0 ? void 0 : data.tokenId) !== null &&
                (data === null || data === void 0 ? void 0 : data.tokenId) !== undefined &&
                data.tokenId !== "" &&
                data.hashStr !== null &&
                data.hashStr !== undefined &&
                data.hashStr !== "" &&
                data.hashStr === generateHashForHmacSHA256(reqId, data.tokenId)) {
                result = subAssignData(result, data, res.success);
            }
            else {
                result.success = false;
                result.message = "Something is went wrong.please try again.";
            }
        }
        else {
            if (res.data === null || res.data == undefined) {
                result.success = false;
                result.message = "Something is went wrong.please try again.";
            }
            else {
                data = res.data;
                result = subAssignData(result, data, res.success);
            }
        }
    }
    return result;
};
export var subAssignData = function (result, data, success) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    result.tokenId = (_a = data === null || data === void 0 ? void 0 : data.tokenId) !== null && _a !== void 0 ? _a : "";
    result.cipToken = (_b = data === null || data === void 0 ? void 0 : data.jwtToken) !== null && _b !== void 0 ? _b : "";
    result.isOtpEnabled = (_c = data === null || data === void 0 ? void 0 : data.isOtpEnabled) !== null && _c !== void 0 ? _c : false;
    result.empType = (_d = data === null || data === void 0 ? void 0 : data.empType) !== null && _d !== void 0 ? _d : "";
    result.success = success;
    result.isSaarthi = (_e = data === null || data === void 0 ? void 0 : data.isSaarthi) !== null && _e !== void 0 ? _e : false;
    result.message = (_f = data === null || data === void 0 ? void 0 : data.message) !== null && _f !== void 0 ? _f : "";
    result.isRH_above = data === null || data === void 0 ? void 0 : data.isRH_above;
    result.partnercategory = (_g = data === null || data === void 0 ? void 0 : data.partnercategory) !== null && _g !== void 0 ? _g : "";
    result.isCasAccess = data === null || data === void 0 ? void 0 : data.isCasAccess;
    result.isMfAccess = data === null || data === void 0 ? void 0 : data.isMfAccess;
    result.hashStrUser = (_h = data === null || data === void 0 ? void 0 : data.hashStrUser) !== null && _h !== void 0 ? _h : "";
    if (!!result.empType && result.empType) {
        result.loginType = data.empType;
    }
    return result;
};
